// extracted by mini-css-extract-plugin
export default {"PremierInfoMessage":"PremierInfoMessage_PremierInfoMessage","PremierInfoIcon":"PremierInfoMessage_PremierInfoIcon","infoMessageTitle":"PremierInfoMessage_infoMessageTitle"};